import Vue from 'vue';

const LISTEN_TAG = 'dn-store';

let $seg;



export default {
  namespaced: true,

  state: {
    totalPer: null,
    subjects: {},
  },

  getters: {
    totalPer: state => state.totalPer,
    subjects: state => state.subjects,
  },

  actions: {
    init({commit, dispatch, rootGetters}) {
      $seg = window.bcBanner.segments;

      commit('restore');
      dispatch('startWatch');
    },

    startWatch({commit}) {
      $seg.scores.listen(e => {
        commit('restore');
      }, LISTEN_TAG);
    },
  },

  mutations: {
    restore: state => {
      const subjects = $seg.scores.getSubjects();
      const totalPer = $seg.scores.getTotalPer();
      Vue.set(state, 'subjects', subjects);
      Vue.set(state, 'totalPer', totalPer);
    },
  },
}


// WEBPACK FOOTER //
// ./src/js/store/modules/segments/modules/score.js